<template>
  <transition name="fade" mode="out-in">
    <section id="pay-result">
      <div class="o-main">
        <div class="o-result">
          <div class="c-head">
            <a href="javascript:void(0)" class="c-head_logo"></a>
          </div>
          <!-- success -->
          <div class="o-succ o-res" v-if="result == SUCCESS">
            <div class="o-state">
              <i class="o-succ_icon"></i>
              <p class="o-state_desc o-succ_desc">主人，恭喜您儲值成功！</p>
            </div>
            <div class="o-order">
              <div class="o-order_item">
                <p class="o-order_title">您的訂單號為：</p>
                <p class="o-order_ctn">{{ orderId }}</p>
              </div>
              <p class="o-desc">
                如對此次儲值有任何疑問，可憑以上訂單號聯繫官方客服郵箱，祝您遊戲愉快！
              </p>
              <p class="o-desc">
                儲值成功後，通常會在15分鐘內，成功到帳，請您耐心等待。
              </p>
              <p class="o-desc">
                客服郵箱：
                <span class="mark-orange">service@3syua.com</span>
              </p>
            </div>
            <div class="c-qr">
              <a
                href="javascript:void(0);"
                @click="reStore"
                class="c-qr_btn j-restore-success-dcount"
              >
                繼續儲值
              </a>
            </div>
          </div>
          <!-- fail -->
          <div class="o-fail o-res" v-if="result == FAIL">
            <div class="o-state">
              <i class="o-fail_icon"></i>
              <p class="o-state_desc o-fail_desc">主人，嗚嗚嗚，儲值出錯了!!</p>
            </div>
            <div class="o-order">
              <div class="o-order_item">
                <p class="o-order_title">出錯原因：</p>
                <p class="o-order_ctn">{{ msg }}</p>
              </div>
              <div class="o-order_item">
                <p class="o-order_title">您的訂單號為：</p>
                <p class="o-order_ctn">{{ orderId }}</p>
              </div>
              <p class="o-desc">
                客服郵箱：
                <span class="mark-orange">service@3syua.com</span>
              </p>
              <p class="o-desc">
                對於此事，我們感到十分抱歉，如需幫助，您可以通過客服郵箱或點擊聯繫客服聯繫我們
              </p>
            </div>
            <div class="c-qr">
              <a
                href="javascript:void(0);"
                @click="reStore"
                class="c-qr_btn j-restore-fail-dcount"
              >
                繼續儲值
              </a>
            </div>
            <div class="c-qr">
              <a
                href="javascript:void(0);"
                @click="showFeebackPage"
                class="c-qr_btn j-contact-us-dcount"
              >
                聯繫客服
              </a>
            </div>
          </div>
        </div>
      </div>
      <form v-bind:action="postAction" method="post">
        <input
          type="hidden"
          name="cardType"
          v-bind:value="post_fields.cardType"
        />
        <input
          type="hidden"
          name="gatewayNo"
          v-bind:value="post_fields.gatewayNo"
        />
        <input
          type="hidden"
          name="goodsInfo"
          v-bind:value="post_fields.goodsInfo"
        />
        <input type="hidden" name="merNo" v-bind:value="post_fields.merNo" />
        <input
          type="hidden"
          name="notifyUrl"
          v-bind:value="post_fields.notifyUrl"
        />
        <input
          type="hidden"
          name="orderAmount"
          v-bind:value="post_fields.orderAmount"
        />
        <input
          type="hidden"
          name="orderCurrency"
          v-bind:value="post_fields.orderCurrency"
        />
        <input
          type="hidden"
          name="orderNo"
          v-bind:value="post_fields.orderNo"
        />
        <input type="hidden" name="remark" v-bind:value="post_fields.remark" />
        <input
          type="hidden"
          name="returnUrl"
          v-bind:value="post_fields.returnUrl"
        />
        <input
          type="hidden"
          name="shopperId"
          v-bind:value="post_fields.shopperId"
        />
        <input
          type="hidden"
          name="signInfo"
          v-bind:value="post_fields.signInfo"
        />
        <input type="hidden" name="token" v-bind:value="post_fields.token" />
        <input
          type="hidden"
          name="verifyBillingAddress"
          v-bind:value="post_fields.verifyBillingAddress"
        />
        <button type="submit" id="postOrderToBank" class="hide"></button>
      </form>
    </section>
  </transition>
</template>
<script>
import globalConfig from '../../utiles/globalConfig';
import { b64DecodeUnicode } from '../../utiles';
import bridge from '../../utiles/bridge';
import { LOAD_INIT_DATA } from '../../store/store';

import {
  getDefaultPayType,
  setDefaultPayType,
  getCurLocation,
  storeCurLocation,
  getStoreHref,
  setDefaultPrice,
  getDefaultPrice,
  getWebviewPageFlag,
  getIsSdk,
  getPostInfo
} from '../../store/twStore/storager';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const mainHost = globalConfig.getMainHost();

const OPEN_BROSWER_METHOD = 'openBrowser';
export default {
  name: 'storeName',
  data() {
    //    let entryParam =  getStoreHrefParam();
    let storeUrlParams = decodeURIComponent(
      globalConfig.getHrefParam('store_url_params').replace('#/result', '')
    );
    let storeParams = b64DecodeUnicode(storeUrlParams);
    let postOrderParams = {};
    const webviewEnv = getWebviewPageFlag() == 1;
    try {
      postOrderParams = JSON.parse(storeParams);
    } catch (e) {
      console.error(e);
    }
    return {
      result: globalConfig.getHrefParam('result'),
      msg: globalConfig.getHrefParam('msg'),
      gameId: globalConfig.getHrefParam('game_id'),
      gameName: globalConfig.getHrefParam('game_name'),
      sid: globalConfig.getHrefParam('server_sid'),
      serverId: globalConfig.getHrefParam('server_id'),
      serverName: globalConfig.getHrefParam('server_name'),
      orderId: globalConfig.getHrefParam('order_id'),
      userId: postOrderParams['userId'],
      SUCCESS: 1,
      FAIL: 0,
      WAITING: 2,
      postOrderParams,
      webviewEnv,
      postAction: '',
      post_fields: {},
      isWeb: postOrderParams['isWeb'],
      roleId: postOrderParams['roleId'],
      roleName: postOrderParams['roleName'],
      cid: postOrderParams['cid'] ? postOrderParams['cid'] : '',
      scid: postOrderParams['scid'] ? postOrderParams['scid'] : '',
      uid: postOrderParams['uid'] ? postOrderParams['uid'] : '',
      loginAccount: postOrderParams['loginAccount']
        ? postOrderParams['loginAccount']
        : '',
      productType: postOrderParams['productType']
        ? postOrderParams['productType']
        : '',
      productId: postOrderParams['productId']
        ? postOrderParams['productId']
        : '',
      cpProductId: postOrderParams['cpProductId']
        ? postOrderParams['cpProductId']
        : '',
      currency: postOrderParams['currency'] ? postOrderParams['currency'] : '',
      amount: postOrderParams['amount'] ? postOrderParams['amount'] : '',
      fPayType: postOrderParams['f_pay_type']
        ? postOrderParams['f_pay_type']
        : '',
      paytype: postOrderParams['paytype'] ? postOrderParams['paytype'] : ''
    };
  },
  computed: {
    languages() {
      return this.$store.state.store.languages;
    }
  },
  created() {
    this.sendResultBiData();
  },
  methods: {
    sendResultBiData() {
      window.webstorev0DataLayer.push({
        eventName: 'payment_result',
        uid: this?.uid || '',
        loginAccount: this?.loginAccount || '',
        roleId: this?.roleId || '',
        roleName: this?.roleName || '',
        serverId: this?.serverId || '',
        cid: this?.cid || '',
        scid: this?.scid || '',
        eventValue: {
          result: this.result,
          product_type: this?.productType || '',
          cp_product_id: this?.cpProductId,
          product_id: this?.productId || '',
          product_num: '1',
          product_currency: this?.currency || '',
          product_money: this?.amount|| '',
          local_currency: this?.currency|| '',
          local_money: this?.amount|| '',
          f_pay_type: this?.fPayType|| '',
          pay_type: this?.paytype|| '',
          order_id: this?.orderId|| '',
          is_coupon: 0,
          coupon_typeid: '',
          coupon_type_name: '',
          coupon_id: '',
          coupon_start_time: '',
          coupon_end_time: '',
          coupon_local_money: '',
          coupon_discount: '',
          uid: this.uid,
          loginAccount: this?.loginAccount || '',
          roleId: this?.roleId || '',
          roleName: this?.roleName || '',
          serverId: this?.serverId,
          cid: this?.cid || '',
          scid: this?.scid || ''
        }
      });
    },
    backGame() {
      bridge.callSdkMethod('closeWebview');
    },
    showFeebackPage() {
      const info = getPostInfo();
      // 如果是web端页面，就跳到临时的web端工单页，因为参数名不一样，所以要处理一下（处理方法：新增）
      let href = getGlobalGetGotoLink({
        link: `https://service.${mainHost}?orderId=${this.orderId}&roleId=${info.roleId}&serverId=${info.server_sid}&gameId=${info.gameId}&serverName=${info.serverName}&roleName=${info.roleName}#/creatework`
      });
      if (getIsSdk() == '0') {
        window.open(href);
      } else {
        bridge.callSdkMethod(OPEN_BROSWER_METHOD, {
          url: href,
          loginDir: 1,
          appendParams: 1
        });
      }
    },
    reStore() {
      let storeLocationVal = getCurLocation();
      let storePrice = getDefaultPrice();
      let storePayType = getDefaultPayType();
      this.$store.dispatch(LOAD_INIT_DATA).then(success => {
        storeCurLocation(storeLocationVal);
        setDefaultPrice(storePrice);
        setDefaultPayType(storePayType);
        let url = getStoreHref();
        location.href = getGlobalGetGotoLink({ link: url });
      });
    }
  }
};
</script>
